export default __webpack_public_path__ + "ef517f027d26cabd95589c70f5f799b7.riv";